import { initializeApp } from 'firebase/app';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAN6mtPN1g6MgUgJWu67cDIVgHM3MkxwZM",
    authDomain: "todo-38160.firebaseapp.com",
    projectId: "todo-38160",
    storageBucket: "todo-38160.appspot.com",
    messagingSenderId: "671580912718",
    appId: "1:671580912718:web:0e74a7f486dea901fc571f"
  };
  



  export {
    firebaseConfig
  }
  